export function parseLocker(url) {	
    const urlRegex = /^([0-9]+)([A-Za-z])([0-9]+)$/;
    const match = url.match(urlRegex);
    if (match) {
        return {
            col: match[1],
            position: match[2],
            line: match[3],
            group: `${match[1]}${match[2]}`,
        };
    } else {
        return null;
    }
}

export function parseLockerKey(url) {	
    const urlRegex = /^([0-9]+)([A-Za-z])$/;
    const match = url.match(urlRegex);
    if (match) {
        return {
            col: match[1],
            position: match[2],
        };
    } else {
        return null;
    }
}